module.exports = __webpack_public_path__ + "img/client-review-hero-img.7144bda9.svg";